import { AxiosError } from 'axios';

interface IApiErrorBody {
  error?: string;
  errors?: { message?: string }[];
  message?: string;
}

/**
 * The text to show the office for a failed request: the API's own message when the
 * response carries one, else the error's message, else `defaultMessage`.
 */
export const getErrorMessage = (
  error: unknown,
  defaultMessage = 'An unexpected error occurred',
): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object' && 'isAxiosError' in error) {
    const axiosError = error as AxiosError<IApiErrorBody | undefined>;
    const apiErrorMessage =
      axiosError.response?.data?.error || axiosError.response?.data?.errors?.[0]?.message;

    return (
      apiErrorMessage || axiosError.response?.data?.message || axiosError.message || defaultMessage
    );
  }

  if (error && typeof error === 'object' && 'message' in error) {
    return (error as Error).message || defaultMessage;
  }

  return defaultMessage;
};
